import { ApiService } from './api.service';
import type { SuggestedModule, SuggestedModuleCreateRequest, SuggestedModuleListResponse } from '@/types';

const BASE_URL = '/api/v1/suggested-modules';

class SuggestedModulesService extends ApiService {
  async getSuggestedModules(cursor?: string) {
    const params = new URLSearchParams();
    if (cursor) params.set('cursor', cursor);
    const qs = params.toString();
    return this.get<SuggestedModuleListResponse>(`${BASE_URL}${qs ? `?${qs}` : ''}`);
  }

  async createSuggestedModule(data: SuggestedModuleCreateRequest) {
    return this.post<SuggestedModule>(BASE_URL, data);
  }

  async updateSuggestedModule(id: string, data: Partial<SuggestedModuleCreateRequest>) {
    return this.put<SuggestedModule>(`${BASE_URL}/${id}`, data);
  }

  async deleteSuggestedModule(id: string) {
    return this.delete<void>(`${BASE_URL}/${id}`);
  }

  async uploadThumbnail(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    return this.post<{ path: string }>(`${BASE_URL}/upload-thumbnail`, formData);
  }
}

export const suggestedModulesService = new SuggestedModulesService();
